var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "profile-main" }, [
    _vm._m(0),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "info-main" },
      [
        _c(
          "el-form",
          {
            directives: [
              {
                name: "loading",
                rawName: "v-loading",
                value: _vm.loading,
                expression: "loading"
              }
            ],
            ref: "profileForm",
            attrs: { model: _vm.profileForm, rules: _vm.rules }
          },
          [
            _c(
              "el-form-item",
              { attrs: { label: "Brand Name", prop: "brandName" } },
              [
                _c("el-input", {
                  attrs: {
                    maxlength: "50",
                    "show-word-limit": "",
                    placeholder: "Brand Name"
                  },
                  model: {
                    value: _vm.profileForm.brandName,
                    callback: function($$v) {
                      _vm.$set(_vm.profileForm, "brandName", $$v)
                    },
                    expression: "profileForm.brandName"
                  }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "el-form-item",
              { attrs: { label: "Primary Category", prop: "primaryCategory" } },
              [
                _c(
                  "el-select",
                  {
                    attrs: {
                      multiple: "",
                      "multiple-limit": 3,
                      filterable: "",
                      placeholder: "Primary Category"
                    },
                    model: {
                      value: _vm.profileForm.primaryCategory,
                      callback: function($$v) {
                        _vm.$set(_vm.profileForm, "primaryCategory", $$v)
                      },
                      expression: "profileForm.primaryCategory"
                    }
                  },
                  _vm._l(_vm.primaryCategoryOptions, function(item) {
                    return _c("el-option", {
                      key: item.value,
                      attrs: { label: item.label, value: item.value }
                    })
                  }),
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "el-form-item",
              {
                attrs: {
                  label: "Do you have a factory?",
                  prop: "isHaveFactory"
                }
              },
              [
                _c(
                  "el-radio-group",
                  {
                    model: {
                      value: _vm.profileForm.isHaveFactory,
                      callback: function($$v) {
                        _vm.$set(_vm.profileForm, "isHaveFactory", $$v)
                      },
                      expression: "profileForm.isHaveFactory"
                    }
                  },
                  [
                    _c("el-radio", { attrs: { label: 1 } }, [_vm._v("Yes")]),
                    _vm._v(" "),
                    _c("el-radio", { attrs: { label: 0 } }, [_vm._v("No")])
                  ],
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "el-form-item",
              { attrs: { label: "Current city", prop: "currentCity" } },
              [
                _c("el-input", {
                  attrs: {
                    maxlength: "50",
                    "show-word-limit": "",
                    placeholder: "Current city"
                  },
                  model: {
                    value: _vm.profileForm.currentCity,
                    callback: function($$v) {
                      _vm.$set(_vm.profileForm, "currentCity", $$v)
                    },
                    expression: "profileForm.currentCity"
                  }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "el-form-item",
              { attrs: { label: "Website", prop: "website" } },
              [
                _c("el-input", {
                  attrs: {
                    placeholder: "Independent website/Amazon/other website URL"
                  },
                  model: {
                    value: _vm.profileForm.website,
                    callback: function($$v) {
                      _vm.$set(_vm.profileForm, "website", $$v)
                    },
                    expression: "profileForm.website"
                  }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "el-form-item",
              {
                attrs: {
                  label: "How many independent stores do you work with?",
                  prop: "independentStores"
                }
              },
              [
                _c(
                  "el-select",
                  {
                    attrs: {
                      placeholder:
                        "How many independent stores do you work with?"
                    },
                    model: {
                      value: _vm.profileForm.independentStores,
                      callback: function($$v) {
                        _vm.$set(_vm.profileForm, "independentStores", $$v)
                      },
                      expression: "profileForm.independentStores"
                    }
                  },
                  _vm._l(_vm.independentStoreoptions, function(item) {
                    return _c("el-option", {
                      key: item.value,
                      attrs: { label: item.label, value: item.value }
                    })
                  }),
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "el-form-item",
              {
                attrs: {
                  label: "How many wholesale products do you sell?",
                  prop: "wholesaleProducts"
                }
              },
              [
                _c(
                  "el-select",
                  {
                    attrs: {
                      placeholder: "How many wholesale products do you sell?"
                    },
                    model: {
                      value: _vm.profileForm.wholesaleProducts,
                      callback: function($$v) {
                        _vm.$set(_vm.profileForm, "wholesaleProducts", $$v)
                      },
                      expression: "profileForm.wholesaleProducts"
                    }
                  },
                  _vm._l(_vm.wholesaleProductsOptions, function(item) {
                    return _c("el-option", {
                      key: item.value,
                      attrs: { label: item.label, value: item.value }
                    })
                  }),
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "el-form-item",
              {
                attrs: { label: "How did you hear about us?", prop: "aboutUs" }
              },
              [
                _c(
                  "el-select",
                  {
                    attrs: { placeholder: "How did you hear about us?" },
                    model: {
                      value: _vm.profileForm.aboutUs,
                      callback: function($$v) {
                        _vm.$set(_vm.profileForm, "aboutUs", $$v)
                      },
                      expression: "profileForm.aboutUs"
                    }
                  },
                  _vm._l(_vm.aboutUsOptions, function(item) {
                    return _c("el-option", {
                      key: item.value,
                      attrs: { label: item.label, value: item.value }
                    })
                  }),
                  1
                )
              ],
              1
            )
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "action",
            on: {
              click: function($event) {
                return _vm.confirm("profileForm")
              }
            }
          },
          [_vm._v("Next")]
        )
      ],
      1
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "info-title" }, [
      _c("p", { staticClass: "title-main" }, [_vm._v("Welcome!")]),
      _vm._v(" "),
      _c("p", { staticClass: "title-subtitle" }, [
        _vm._v("Fill in brand information and detailed information")
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6c147a54", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6c147a54","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/home/brand-review/profile.vue
// module id = wPmZ
// module chunks = 2